<dialog-draggable-header>Manage Request Access</dialog-draggable-header>

<mat-dialog-content>
   <data-table [data]="requestors" [columns]="columns" [paging]="true" [totalRecords]="total" [loading]="loading"
      (select)="updateSelectedRequestor($event)" [pageSize]="this.pageOptions.size" [lazy]="true"
      (lazyLoad)="onLazyLoad($event)" [filterColumnDisplay]="false">
      <ng-container actionStart>
         <button mat-button [disabled]="!hasSelectedRequestor" (click)="onDenyAccessClick()"
            (keypress.enter)="onDenyAccessClick()">Deny User Access</button>
         <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
         <button mat-button [disabled]="!hasSelectedRequestor" (click)="onGrantAccessClick()"
            (keypress.enter)="onGrantAccessClick()">Grant User Access</button>
      </ng-container>
      <ng-container actionEnd>
         <button mat-button mat-dialog-close>Close</button>
      </ng-container>
   </data-table>
</mat-dialog-content>
